<template>
  <div id="app" class="leading-normal transition duration-300 ease-in font-display bg-quaternary">
    <Container/>
  </div>
</template>

<script>
import Container from './Container.vue'

export default {
  name: 'App',
  components: {
    Container
  }
}
</script>